export default {
  getStudentsRequest (state) {
    state.students = []
  },
  getStudentsSuccess (state, data) {
    state.students = data
    state.ordering = data.ordering
  },
  getStudentsFailure (state) {
    state.students = []
  },
  getStudentsWithUnenrolledRequest(state) {
    state.students = []
  },
  getStudentsWithUnenrolledSuccess(state, data) {
    state.students = data
    state.ordering = data.ordering
  },
  getStudentsWithUnenrolledFailure(state) {
    state.students = []
  },
  getStudentsByDueMonthRequest(state) {
    state.students = []
  },
  getStudentsByDueMonthSuccess(state, data) {
    state.students = data
    state.ordering = data.ordering
  },
  getStudentsByDueMonthFailure(state) {
    state.students = []
  },
  getStudentByIdRequest (state) {
    state.loading = true
    state.student = {}
  },
  getStudentByIdSuccess (state, data) {
    state.loading = false
    state.student = data
  },
  getStudentByIdFailure (state) {
    state.loading = false
    state.student = {}
  },
  addStudentRequest (state) {
    state.loading = true
  },
  addStudentSuccess (state) {
    state.loading = false
  },
  addStudentFailure (state) {
    state.loading = false
  },
  updateStudentRequest (state) {
    state.loading = true
  },
  updateStudentSuccess (state, data) {
    state.loading = false
    state.student = data
  },
  updateStudentFailure (state) {
    state.loading = false
  }
}
